import { useCallback, useEffect, useRef } from "react";

import { getOptionsHighlighted } from "..";
import { getOptionsWithTooltips, getSeriesNameStrippingForecast } from "../../util";

/**
 * Handle on Hover event to highlight series.
 * Handle on Hover event to apply unique tooltips based on the highlighted series
 */
const useHoverOnSeries = (
  echarts,
  options,
  currentlyHighlightedTrace,
  setOptionsToChart
) => {
  // Two forecast sources strip to the same product, so the tooltip tracks the exact series.
  const hoveredSeriesName = useRef<string>(null);

  const onHover = useCallback(
    (e) => {
      const hasSeriesData: boolean =
        e.seriesIndex >= 0 && e.seriesIndex < options.series?.length;

      if (!hasSeriesData) return;

      const series = options.series[e.seriesIndex];
      const traceName = getSeriesNameStrippingForecast(series?.name);

      if (
        traceName !== currentlyHighlightedTrace.current ||
        series.name !== hoveredSeriesName.current
      ) {
        currentlyHighlightedTrace.current = traceName;
        hoveredSeriesName.current = series.name;

        const highlightedOptions = getOptionsHighlighted(options, traceName);
        const optionsWithTooltips = getOptionsWithTooltips(
          highlightedOptions,
          traceName,
          series.name
        );

        setOptionsToChart(optionsWithTooltips);
      }
    },
    [currentlyHighlightedTrace, options, setOptionsToChart]
  );

  useEffect(() => {
    if (!echarts) return;
    echarts.on("hover", onHover);

    return () => {
      echarts.off("hover", onHover);
    };
  }, [echarts, onHover]);
};

export default useHoverOnSeries;
